import axios from "axios"
import { useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"

const BASE_URL = "https://sharie.vercel.app/api/" ///"https://sharie-mfgc.onrender.com/api/" //"http://localhost:5000/api/"
const domain = "https://www.sharie.co.il" //"localhost:3000"
let isRefreshing = false
let failedQueue = []

// Create Axios instance
const axiosInstance = axios.create({
  baseURL: BASE_URL,
  withCredentials: true, // ✅ Keep this
  headers: {
    "Content-Type": "application/json",
  },
})

// Add a request interceptor to attach Authorization token
axiosInstance.interceptors.request.use(
  (config) => {
    config.withCredentials = true // ✅ Ensures cookies are always sent
    return config
  },
  (error) => Promise.reject(error)
)

// Add a response interceptor for handling errors globally

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })
  failedQueue = []
}

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config

    if (
      error.response &&
      (error.response.status === 401 || error.response.status === 403) &&
      !originalRequest._retry
    ) {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject })
        })
          .then(() => {
            return axiosInstance(originalRequest)
          })
          .catch((err) => {
            return Promise.reject(err)
          })
      }

      originalRequest._retry = true
      isRefreshing = true

      try {
        await axiosInstance.post("/users/refresh-token") // ✅ Actually calling your endpoint!
        processQueue(null)
        return axiosInstance(originalRequest) // 🔥 retry the original request after refresh
      } catch (refreshError) {
        processQueue(refreshError, null)
        return Promise.reject(refreshError)
      } finally {
        isRefreshing = false
      }
    }

    return Promise.reject(error)
  }
)

export const useApiService = () => {
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const getData = async (endpoint) => {
    try {
      setLoading(true)
      const response = await axiosInstance.get(endpoint)
      setLoading(false)

      return response.data
    } catch (error) {
      setLoading(false)

      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        if (!location.pathname.startsWith("/reset-password")) navigate("/") // Redirect on 401 or 403
      } else {
        //console.error("Axios GET error:", error)
        //throw error // Handle in calling component if needed
      }
    }
  }

  const postData = async (endpoint, payload) => {
    try {
      setLoading(true)

      //const start = performance.now()
      const response = await axiosInstance.post(endpoint, payload)
      setLoading(false)

      // const end = performance.now() // End timing
      // const duration = Math.round(end - start)
      // console.log(`[API] ${endpoint} responded in ${duration}ms`)
      return response.data
    } catch (error) {
      setLoading(false)

      if (error.response && (error.response.status === 401 || error.response.status === 403)) {
        if (!location.pathname.startsWith("/reset-password")) navigate("/") // Redirect on 401 or 403
      } else {
        //console.error("Axios POST error:", error)
        //throw error // Handle in calling component if needed
      }
    }
  }

  return { getData, postData, BASE_URL, domain, loading }
}
